import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton, Tooltip } from "@mui/material";
import { $getSelection } from "lexical";
import { type FC, useCallback } from "react";
import { $isDesignHuddleNode } from "../../nodes/design-huddle-node";
import { $isImageNode } from "../../nodes/image-node";
import { $isPollNode } from "../../nodes/poll/helpers";
import { $isVideoNode } from "../../nodes/video-node";
import { DELETE_NODE_COMMAND } from "../../types/commands";
import { floatingToolbarStyles } from "./floating-toolbar-styles";
import type { ToolbarProps } from "./props";

export const DeleteNodeButton: FC<ToolbarProps> = ({ disabled, mode = "toolbar" }) => {
  const [editor] = useLexicalComposerContext();

  const onClick = useCallback(() => {
    editor.getEditorState().read(() => {
      const selection = $getSelection();
      const node = selection?.getNodes()[0];
      if (
        $isImageNode(node) ||
        $isDesignHuddleNode(node) ||
        $isPollNode(node) ||
        $isVideoNode(node)
      ) {
        editor.dispatchCommand(DELETE_NODE_COMMAND, node.getKey());
      }
    });
  }, [editor]);

  return (
    <Tooltip title="Delete">
      <IconButton
        data-analytics-id={`lexical-${mode}-delete-node`}
        disabled={disabled}
        data-testid={`${mode}-button-delete-node`}
        aria-label="Delete"
        tabIndex={-1}
        sx={{
          ...floatingToolbarStyles[mode].button,
          backgroundColor: "background.neutral",
        }}
        onClick={onClick}
      >
        <DeleteIcon sx={floatingToolbarStyles[mode].formatIcon} />
      </IconButton>
    </Tooltip>
  );
};
